
















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component({
  components: { }
})
export default class HonjoSection extends Vue {
  @Prop(String) title!: string

  @Prop(String) subtitle!: string
}
